import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../components/navbar'
import AccordionTwo from '../components/accordion-two'
import FooterLight from '../components/footer-light'
import NavTab from '../components/demo/nav-tab'
import Modal from '../components/demo/modal'
import ShapeTwo from '../components/shape-two'

import bg from '../assets/images/bg.jpg'
import client from '../assets/images/client/05.jpg'

import { badges, btn, btnOutLine, progress, textColor } from '../data/components'

export default function Components() {
  return (
    <>
     <Navbar/> 
     <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-white"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title">Components</h4>
                            <p className="text-muted mb-0">All Components and Elements are here,</p>
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Support</Link></li>
                            <li className="list-inline-item">
                                <span className="text-uppercase text-primary fw-bold">Components</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> 
        <div className="home-shape-arrow">
            <Link to="#" className="mouse-down"><i className="mdi mdi-arrow-down arrow-icon text-dark h5"></i></Link>
        </div>
    </section>
    <ShapeTwo/>

    <section className="section" id="components">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="row pb-5">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Heading</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <h6 className="text-muted mb-4 pb-2">Ex. <code className="text-danger">&lt;h1&gt; H1. Bootstrap heading &lt;/h1&gt;</code></h6>

                                <h1>H1. Bootstrap heading</h1>
                                <h2>H2. Bootstrap heading</h2>
                                <h3>H3. Bootstrap heading</h3>
                                <h4>H4. Bootstrap heading</h4>
                                <h5>H5. Bootstrap heading</h5>
                                <h6>H6. Bootstrap heading</h6>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Display</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;p className="display-1"&gt; Display 1 &lt;/p&gt;</code></h6>

                                <p className="display-1">Display 1</p>
                                <p className="display-2">Display 2</p>
                                <p className="display-3">Display 3</p>
                                <p className="display-4">Display 4</p>
                                <p className="display-5">Display 5</p>
                                <p className="display-6">Display 6</p>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Buttons</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <h6 className="mb-3 text-muted">Simple Buttons</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;Link to="#" className="btn btn-primary"&gt; Primary &lt;/Link&gt;</code>
                                </h6>
                                {btn.map((item,index)=>{
                                  return(
                                    <Link to="#" className={`btn mb-3 me-2 ${item.style}`} key={index}>{item.title}</Link>
                                  )
                                })}

                                <h6 className="mb-3 mt-5 text-muted">Buttons Pills</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;Link to="#" className="btn btn-primary rounded-pill"&gt; Primary &lt;/Link&gt;</code>
                                </h6>
                                {btn.map((item,index)=>{
                                  return(
                                    <Link to="#" className={`btn mb-3 rounded-pill me-2 ${item.style}`} key={index}>{item.title}</Link>
                                  )
                                })}

                                <h6 className="mb-3 mt-5 text-muted">Outline Buttons</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;Link to="#" className="btn btn-outline-primary"&gt; Primary &lt;/Link&gt;</code>
                                </h6>
                                {btnOutLine.map((item,index)=>{
                                  return(
                                    <Link to="#" className={`btn mb-3 me-2 ${item.style}`} key={index}>{item.title}</Link>
                                  )
                                })}

                                <h6 className="mb-3 mt-5 text-muted">Outline Buttons Pills</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;Link to="#" className="btn btn-outline-primary rounded-pill"&gt; Primary &lt;/Link&gt;</code>
                                </h6>
                                {btnOutLine.map((item,index)=>{
                                  return(
                                    <Link to="#" className={`btn mb-3 me-2 rounded-pill ${item.style}`} key={index}>{item.title}</Link>
                                  )
                                })}

                                <h6 className="mb-3 mt-5 text-muted">Buttons Sizing</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;Link to="#" className="btn btn-primary btn-sm"&gt; Primary &lt;/Link&gt;</code>
                                </h6>
                                <Link to="#" className="btn btn-primary btn-sm mb-3 me-2">Primary</Link>
                                <Link to="#" className="btn btn-warning mb-3 me-2">Warning</Link>
                                <Link to="#" className="btn btn-success btn-lg mb-3 me-2">Success</Link>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Alert</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <h6 className="mb-3 text-muted">Simple Alert</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;div className="alert alert-primary" role="alert"&gt; A simple primary alert—check it out! &lt;/div&gt;</code>
                                </h6>
                                <div className="alert alert-primary" role="alert"> A simple primary alert—check it out!</div>
                                <div className="alert alert-secondary" role="alert"> A simple secondary alert—check it out!</div>
                                <div className="alert alert-danger" role="alert"> A simple danger alert—check it out!</div>

                                <h6 className="mb-3 mt-5 text-muted">Alert Link</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;div className="alert alert-primary" role="alert"&gt; A simple primary alert with &lt;Link to="#" className="alert-link"&gt;&lt;/Link&gt;. &lt;/div&gt;</code>
                                </h6>
                                <div className="alert alert-primary" role="alert">A simple primary alert with <Link to="#" className="alert-link">an link</Link>.</div>
                                <div className="alert alert-secondary" role="alert">A simple secondary alert with <Link to="#" className="alert-link">an link</Link>.</div>
                                <div className="alert alert-danger" role="alert">A simple danger alert with <Link to="#" className="alert-link">an link</Link>.</div>

                                <h6 className="mb-3 mt-5 text-muted">Additional Content</h6>
                                <div className="alert alert-success" role="alert">
                                    <h4 className="alert-heading">Well done!</h4>
                                    <p className="mb-0">Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.</p>
                                    <hr className="my-3"/>
                                    <p className="mb-0">Whenever you need to, be sure to use margin utilities to keep things nice and tidy.</p>
                                </div>

                                <h6 className="mb-3 mt-5 text-muted">Dismissing Alert</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;div className="alert alert-success alert-dismissible fade show" role="alert"&gt; &lt;strong&gt;Well done!&lt;/strong&gt; You successfully read this important alert message. &lt;button type="button" className="close" data-dismiss="alert" aria-label="Close"&gt; &lt;span aria-hidden="true"&gt; &times; &lt;/span&gt; &lt;/button&gt;  &lt;/div&gt;</code>
                                </h6>
                                <div className="alert alert-warning alert-dismissible fade show" role="alert">
                                    <strong>Holy guacamole!</strong> You should check in on some of those fields below.
                                    <button type="button" className="btn-close" data-bs-dismiss="alert"
                                        aria-label="Close"></button>
                                </div>

                                <h6 className="mb-3 mt-5 text-muted">Modern Alert</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;div className="alert alert-primary alert-pills" role="alert"&gt; <br/> &lt;span className="badge bg-danger rounded-pill"&gt; New &lt;/span&gt; <br/> &lt;span className="alert-content"&gt; A Modern primary alert—check it out! &lt;/span&gt; <br/>  &lt;/div&gt;</code>
                                </h6>
                                <div className="d-block">
                                    <div className="alert alert-primary alert-pills" role="alert">
                                        <span className="badge bg-info rounded-pill">New</span>
                                        <span className="content">A Modern primary alert—check it out! <i className="mdi mdi-chevron-right"></i></span>
                                    </div>
                                </div>

                                <div className="d-block">
                                    <div className="alert alert-danger alert-pills" role="alert">
                                        <span className="badge bg-success rounded-pill"> New </span>
                                        <span className="content"> A Modern danger alert—check it out! <i className="mdi mdi-chevron-right"></i> </span>
                                    </div>
                                </div>

                                <h6 className="mb-3 mt-5 text-muted">Modern Alert Outline</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;div className="alert alert-outline-primary alert-pills" role="alert"&gt; <br/> &lt;span className="badge bg-danger rounded-pill"&gt; New &lt;/span&gt; <br/> &lt;span className="alert-content"&gt; A Modern primary alert—check it out! &lt;/span&gt; <br/>  &lt;/div&gt;</code>
                                </h6>
                                <div className="d-block">
                                    <div className="alert alert-outline-primary alert-pills" role="alert">
                                        <span className="badge bg-info rounded-pill">New</span>
                                        <span className="content">A Modern primary alert—check it out! <i className="mdi mdi-chevron-right"></i></span>
                                    </div>
                                </div>

                                <div className="d-block">
                                    <div className="alert alert-outline-danger alert-pills" role="alert">
                                        <span className="badge bg-success rounded-pill"> New </span>
                                        <span className="content"> A Modern danger alert—check it out! <i className="mdi mdi-chevron-right"></i> </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Badges</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <h6 className="mb-3 text-muted">Badges</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. <code
                                        className="text-danger">&lt;span className="badge bg-primary"&gt; primary &lt;/span&gt;</code>
                                </h6>
                                {badges.map((item,index)=>{
                                  return(
                                    <span className={`badge me-2 mb-2 ${item.style}`} key={index}>{item.title}</span>
                                  )
                                })}

                                <h6 className="mb-3 mt-5 text-muted">Badges Pills</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. <code
                                        className="text-danger">&lt;span className="badge bg-primary rounded-pill"&gt; primary &lt;/span&gt;</code>
                                </h6>
                                {badges.map((item,index)=>{
                                  return(
                                    <span className={`badge me-2 mb-2 rounded-pill ${item.style}`} key={index}>{item.title}</span>
                                  )
                                })}

                                <h6 className="mb-3 mt-5 text-muted">Link Badges</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. <code
                                        className="text-danger">&lt;Link to="#" className="badge bg-primary"&gt; primary &lt;/Link&gt;</code>
                                </h6>
                                {badges.map((item,index)=>{
                                  return(
                                    <Link to="#" className={`badge me-2 mb-2 ${item.style}`} key={index}>{item.title}</Link>
                                  )
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Text Color</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;div className="text-primary"&gt; Pioneer One Global &lt;/div&gt;</code>
                                </h6>
                                {textColor.map((item,index)=>{
                                  return(
                                    <h6 className={item.style} key={index}>{item.title}</h6>
                                  )
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Navtabs</h4>
                            </div>
                        </div>

                        <NavTab/>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Modal</h4>
                            </div>
                        </div>

                        <Modal/>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Breadcrumbs</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4 page-next-level">
                                <ul className="page-next px-0 mb-0">
                                    <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Home</Link></li>
                                    <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                                    <li className="list-inline-item"><span className="text-uppercase text-primary fw-bold">Components</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Avatar</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <h6 className="mb-3 text-muted">Default Avatar</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;img src="images/home/01.jpg" className="img-fluid avatar avatar-small rounded"&gt;</code>
                                </h6>
                                <img src={client} className="img-fluid avatar avatar-ex-sm me-3 rounded" alt=""/>
                                <img src={client} className="img-fluid avatar avatar-small me-3 rounded" alt=""/>
                                <img src={client} className="img-fluid avatar avatar-medium me-3 rounded"alt=""/>
                                <img src={client} className="img-fluid avatar avatar-large mt-3 mt-sm-0 me-3 rounded" alt=""/>

                                <h6 className="mb-3 mt-5 text-muted">Circle Avatar</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;img src="images/home/01.jpg" className="img-fluid avatar avatar-small rounded-pill"&gt;</code>
                                </h6>
                                <img src={client} className="img-fluid avatar avatar-ex-sm me-3 rounded-pill" alt=""/>
                                <img src={client} className="img-fluid avatar avatar-small me-3 rounded-pill" alt=""/>
                                <img src={client} className="img-fluid avatar avatar-medium me-3 rounded-pill" alt=""/>
                                <img src={client} className="img-fluid avatar avatar-large mt-3 mt-sm-0 me-3 rounded-pill" alt=""/>

                                <h6 className="mb-3 mt-5 text-muted">Thumbnail Avatar</h6>
                                <h6 className="text-muted mb-4 pb-2">Ex. <code className="text-danger">&lt;img src="images/home/01.jpg" className="img-fluid img-thumbnail avatar avatar-small rounded"&gt;</code>
                                </h6>
                                <img src={client} className="img-fluid avatar avatar-ex-sm img-thumbnail me-3 rounded" alt=""/>
                                <img src={client} className="img-fluid avatar avatar-small img-thumbnail me-3 rounded" alt=""/>
                                <img src={client} className="img-fluid avatar avatar-medium img-thumbnail me-3 rounded" alt=""/>
                                <img src={client} className="img-fluid avatar avatar-large img-thumbnail mt-3 mt-sm-0 me-3 rounded"alt=""/>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Accordion</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <AccordionTwo/>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Pagination</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <ul className="pagination mb-0 list-unstyled">
                                    <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border"> Prev</Link></li>
                                    <li className="active"><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">1</Link></li>
                                    <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">2</Link></li>
                                    <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">3</Link></li>
                                    <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">4</Link></li>
                                    <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">Next </Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Progressbar</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                              {progress.map((item,index)=>{
                                return(
                                    <div className="progress-box mt-4" key={index}>
                                        <h6 className="title text-muted">{item.title}</h6>
                                        <div className="progress">
                                            <div className="progress-bar progress-bar-striped position-relative bg-primary" style={{width:item.value}}>
                                                <div className="progress-value d-block text-muted h6">{item.value}</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                              })}
                            </div>
                        </div>
                    </div>

                    <div className="row pb-5 pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Forms & Inputs</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <h6 className="mb-3 text-muted">Form</h6>
                                <form>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Your Name <span className="text-danger">*</span></label>
                                                <input name="name" id="name" type="text" className="form-control" placeholder="First Name :"/>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                                <input name="email" id="email" type="email" className="form-control" placeholder="Your email :"/>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="form-label">Subject</label>
                                                <input name="subject" id="subject" className="form-control" placeholder="Your subject :"/>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="form-label">Comments</label>
                                                <textarea name="comments" id="comments" rows="4" className="form-control" placeholder="Your Message :"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 text-center">
                                            <div className="d-grid">
                                                <input type="submit" id="submit" name="send" className="btn btn-primary" value="Send Message"/>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                <h6 className="mb-3 mt-5 text-muted">Checkboxes</h6>
                                <div className="form-check form-check-inline">
                                    <div className="mb-0">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" defaultChecked  id="flexCheckDefault1"/>
                                            <label className="form-check-label" htmlFor="flexCheckDefault1">One</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-check form-check-inline">
                                    <div className="mb-0">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id="flexCheckDefault2"/>
                                            <label className="form-check-label" htmlFor="flexCheckDefault2">Two</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-check form-check-inline">
                                    <div className="mb-0">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" disabled id="flexCheckDefault3"/>
                                            <label className="form-check-label" htmlFor="flexCheckDefault3">Disabled</label>
                                        </div>
                                    </div>
                                </div>

                                <h6 className="mb-3 mt-5 text-muted">Radio Buttons</h6>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <div className="form-check mb-0">
                                        <input className="form-check-input" defaultChecked type="radio" name="flexRadioDefault" id="flexRadioDefault1"/>
                                        <label className="form-check-label" htmlFor="flexRadioDefault1">Yes</label>
                                    </div>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <div className="form-check mb-0">
                                        <input className="form-check-input" defaultChecked type="radio" name="flexRadioDefault" id="flexRadioDefault2"/>
                                        <label className="form-check-label" htmlFor="flexRadioDefault2">No</label>
                                    </div>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <div className="form-check mb-0">
                                        <input className="form-check-input" defaultChecked type="radio" disabled name="flexRadioDefault" id="flexRadioDefault3"/>
                                        <label className="form-check-label" htmlFor="flexRadioDefault3">Disabled</label>
                                    </div>
                                </div>

                                <h6 className="mb-3 mt-5 text-muted">Switches Button</h6>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Default switch checkbox input</label>
                                </div>

                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" defaultChecked/>
                                    <label className="form-check-label" htmlFor="flexSwitchCheckChecked">Checked switch checkbox input</label>
                                </div>

                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDisabled" disabled/>
                                    <label className="form-check-label" htmlFor="flexSwitchCheckDisabled">Disabled switch checkbox input</label>
                                </div>

                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckCheckedDisabled" defaultChecked disabled/>
                                    <label className="form-check-label" htmlFor="flexSwitchCheckCheckedDisabled">Disabled checked switch checkbox input</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row pt-5 border-top">
                        <div className="col-md-3">
                            <div className="component-wrapper sticky-bar">
                                <h4 className="title mb-0">Icons</h4>
                            </div>
                        </div>

                        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div className="ms-md-4">
                                <h6 className="mb-3 text-muted">Material Design Icons</h6>
                                <p className="text-muted">There are 4800+ Material Design icons and you can get all icons info from here: <Link to="https://materialdesignicons.com/" target="_blank">
                                <code className="text-primary">https://materialdesignicons.com/</code></Link></p>
                                <h6 className="text-muted mb-4 pb-2">Ex. 
                                  <code className="text-danger">&lt;i className="mdi mdi-home"&gt; &lt;/i&gt;</code></h6>

                                <i className="mdi mdi-home h4 me-2"></i>
                                <i className="mdi mdi-facebook h4 me-2"></i>
                                <i className="mdi mdi-chevron-tight h4 me-2"></i>
                                <i className="mdi mdi-camera-image h4 me-2"></i>
                                <i className="mdi mdi-car-light-high h4 me-2"></i>
                                <i className="mdi mdi-silverware-fork-knife h4 me-2"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <ShapeTwo/>
    <FooterLight/>
    </>
  )
}
